import { useEffect, useState } from 'react';
import { PersonWorkspace } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';
import Authentication from '../../../../libs/api/services/Authentication';
import PatientProfileDetailsContainer from './components/PatientProfileDetailsContainer';
import PatientProfileRelationships from './PatientProfileRelationships';
import PatientProfileShare from './PatientProfileShare';
import PatientProfileSharedWith from './PatientProfileSharedWith';

export default function PatientProfileManagement({ patientUserID, onSaved, type, ownProfile, className }) {

    const { id } = useParams();
    const [mode, setMode] = useState()

    useEffect(() => {
        Authentication.setActivePatient(id ? id : patientUserID)
        return () => { Authentication.clearActivePatient() }
    }, [id])

    const [profile, setProfile] = useState({ id: id ? id : patientUserID ? patientUserID : undefined, profiles: [] })

    if (profile.id === '00000000-0000-0000-0000-000000000000' && ownProfile)
        return <div className='d-flex flex-grow-1 flex-column align-items-center justify-content-center'><PersonWorkspace size={80} /> <h3>There is no patient profile linked to you</h3><p>Once you are linked to your clinician you will be able to manage your profile</p></div>
    return (
        <>
            <div className=' d-flex flex-shrink-1 ' style={{ height: '38px' }} >
                <button onClick={() => setMode()} className={`btn w-100 rounded-0 ${!mode ? 'shadow bg-primary-container' : 'bg-secondary-container'}`}>Profile</button>
                {!Authentication.getShareID() && <button onClick={() => setMode('Teams')} className={`btn w-100 rounded-0 ${mode === 'Teams' ? 'shadow bg-primary-container' : 'bg-secondary-container'}`}>Relationships</button>}
                {!Authentication.getShareID() && <button onClick={() => setMode('Share')} className={`btn w-100 rounded-0 ${mode === 'Share' ? 'shadow bg-primary-container' : 'bg-secondary-container'}`}>Share</button>}
            </div>
            <div className='d-flex flex-column flex-grow-1 ' style={{ maxHeight: 'calc(100% - 38px)' }}>
                {
                    {
                        'Teams': <PatientProfileRelationships patientUserID={id ? id : patientUserID ? patientUserID : Authentication.patientUserID()} />,
                        'Share': patientUserID ? <PatientProfileSharedWith /> : <PatientProfileShare />,
                    }[mode] || <PatientProfileDetailsContainer
                        id={id}
                        mode={mode}
                        profile={profile}
                        setProfile={setProfile}
                        patientUserID={patientUserID}
                    />
                }
            </div>
        </>
    )
}
